var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "voice-message-pick-list__item-content" }, [
      _c("div", { staticClass: "voice-message-pick-list__item-title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "voice-message-pick-list__item-desc" }, [
        _vm._v(_vm._s(_vm.description)),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "voice-message-pick-list__item-tags ml-2" }, [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "fas fa-star",
      }),
      _vm._v(" "),
      _vm.isForeign
        ? _c("span", { staticClass: "badge badge-purple" }, [
            _vm._v("shared by " + _vm._s(_vm.ownerName)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "voice-message-pick-list__item-actions ml-2" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary btn-sm",
          attrs: { disabled: _vm.hasActive },
          on: {
            click: function ($event) {
              return _vm.select(_vm.id)
            },
          },
        },
        [
          _vm.isActive
            ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
            : _c("i", { staticClass: "fas fa-play" }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }